<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-resources-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Resources',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreResourcesView: () => import('../components/core/ResourcesView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
